/**
 * Extract selected add-on names from form values.
 * Form stores add-ons as { addOns: { "name1": ["name1"], "name2": [] } }
 * Returns array of selected names: ["name1"]
 */
export const extractSelectedAddOns = (formAddOns = {}) => {
  return Object.entries(formAddOns).reduce((acc, [key, value]) => {
    if (Array.isArray(value) && value.length > 0) {
      acc.push(key);
    }
    return acc;
  }, []);
};

/**
 * Build protectedData add-ons for checkout.
 * Looks up each selected add-on in the listing's addOns array and
 * formats the price for storage (converts subunit amount to display amount).
 */
export const buildProtectedAddOns = (selectedNames, listingAddOns = []) => {
  return selectedNames.reduce((acc, name) => {
    const addOnConfig = listingAddOns.find(a => a.name === name);
    if (addOnConfig) {
      const { price } = addOnConfig;
      const displayAmount = price.amount
        ? Number(String(price.amount).slice(0, -2) || '0')
        : 0;
      acc.push({
        ...addOnConfig,
        price: { ...price, amount: displayAmount },
      });
    }
    return acc;
  }, []);
};
